export enum NotificationFilter {
  VOTES = "rvotes",
  MENTIONS = "mentions",
  FAVORITES = "nfavorites",
  BOOKMARKS = "nbookmarks",
  FOLLOWS = "follows",
  REPLIES = "replies",
  REBLOGS = "reblogs",
  TRANSFERS = "transfers",
  DELEGATIONS = "delegations",
  PAYOUTS = "payouts",
  SCHEDULED_PUBLISHED = "scheduled_published",
}
